import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { DateTimeValue, DateValue } from 'app/shared/lib/date-time';
import { EssDatetimeCustomElement } from 'app/shared/elements/forms/ess-datetime';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssDateTimePage extends ComponentBase {

    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////

    protected ex2MaxDate?: string | null = null;
    protected ex2MinDate?: string | null = null;
    protected ex2MaxTime?: string | null = "18:00";
    protected ex2MinTime?: string | null = "06:00";

    @observable({ changeHandler: 'calculateMinDate' })
    protected ex2MinDateOffset?: number | null = null;
    @observable({ changeHandler: 'calculateMaxDate' })
    protected ex2MaxDateOffset?: number | null = null;
    @observable({ changeHandler: 'calculateMinTime' })
    protected ex2MinTimeOffset?: number | null = null;
    @observable({ changeHandler: 'calculateMaxTime' })
    protected ex2MaxTimeOffset?: number | null = null;

    protected calculateMinDate(...args: any[]): void {
        if(this.ex2MinDateOffset) {
            let dateVal = new DateValue(this.env.today).add(this.ex2MinDateOffset, 'days');
            this.ex2MinDate = dateVal.toString();
        }
        else {
            this.ex2MinDate = null;
        }
    }

    protected calculateMaxDate(...args: any[]): void {
        if(this.ex2MaxDateOffset) {
            let dateVal = new DateValue(this.env.today).add(this.ex2MaxDateOffset, 'days');
            this.ex2MaxDate = dateVal.toString();
        }
        else {
            this.ex2MaxDate = null;
        }
    }

    protected calculateMinTime(...args: any[]): void {
        if(this.ex2MinTimeOffset == 0 || this.ex2MinTimeOffset) {
            let timeVal = new DateTimeValue(this.env.now()).add(this.ex2MinTimeOffset, 'hours');
            this.ex2MinTime = timeVal.toString();
        }
        else {
            this.ex2MinTime = null;
        }
    }

    protected calculateMaxTime(...args: any[]): void {
        if(!!this.ex2MaxTimeOffset) {
            let timeVal = new DateTimeValue(this.env.now()).add(this.ex2MaxTimeOffset, 'hours');
            this.ex2MaxTime = timeVal.toString();
        }
        else {
            this.ex2MaxTime = null;
        }
    }

    ////****************** Example 3 ********************************************////

    protected ex3UseSeconds: boolean = true;
    protected ex3Use24Hour: boolean = true;

    ////****************** Example 4 ********************************************////

    protected ex4Label: string | null = 'Select a Date/Time';
    protected ex4RequiredValidatorLabel: string | null = 'Date/Time';

}
